/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import EditSocialHeader from 'app/components/Headers/EditSocialHeader.jsx';
import SocialEditorTabs from 'app/components/EditorComponents/SocialEditorTabs.jsx';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import ButtonList from 'app/components/common/ButtonList.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import SocialConfigButtons from 'app/mixins/SocialConfigButtons.js';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import * as _ from 'underscore';
import Utilities from 'app/utility/Utilities.js';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class SocialEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            socialId: 0,
            social: {},
            cleanSocial: {},
            errors: null,
            buttonParams: {}
        };

        this.updateSocial = this.updateSocial.bind(this);
        this.deleteSocial = this.deleteSocial.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        if (state.socialId && _.isEmpty(state.social)) {
            for (let i = 0; i < props.socials.list.length; ++i) {
                if (props.socials.list[i].id == state.socialId && props.socials.list[i].params !== undefined) {
                    nextState.social = Utilities.deepClone(props.socials.list[i]);
                    nextState.cleanSocial = Utilities.deepClone(props.socials.list[i]);
                    break;
                }
            }
        }

        let errors = props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE', 'SOCIAL_DELETE']);
        if (errors.length) {
            nextState.errors = errors;
        } else if (state.errors && !errors.length) {
            nextState.errors = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {
        let socialId = 0;

        socialId = this.props.router.params.socialId;

        // no id, redirect them to the list of socials
        if (!socialId) {
            this.props.router.navigate('/config/socials');
        }

        this.setState({
            socialId: socialId,
            buttonParams: {socialId: socialId}
        });

        if (this.props.app.firstLoad.SOCIAL_LIST === false) {
            this.props.getSocials();
        }

        this.props.getSocial(socialId);
    }

    componentDidUpdate(prevProps, prevState) {

        if ((prevProps.app.loading.SOCIAL_UPDATE === true && this.props.app.loading.SOCIAL_UPDATE === false) ||
            (prevProps.app.loading.SOCIAL_DELETE === true && this.props.app.loading.SOCIAL_DELETE === false)) {
            if (this.state.errors === null) {
                this.props.router.navigate('/config/socials');
            }
        }

    }

    updateSocial(e) {

        e.preventDefault();

        this.props.deleteApiError(['SOCIAL_UPDATE']);
        this.props.updateSocial(this.state.social);

    }

    deleteSocial(e) {

        let cancelDelete = () => {
                this.props.closeAllModals();
            },
            confirmDelete = (e) => {
                e.preventDefault();
                this.props.deleteSocial(this.state.social.id);
                this.props.closeAllModals();
            },
            modal = (
                <DeleteModal
                    modalCopy={"Are you sure you want to remove this social?"}
                    cancelAction={cancelDelete}
                    confirmAction={confirmDelete} />
            );

        e.preventDefault();

        this.props.addModal(modal);

    }

    cancelEdit(e) {

        e.preventDefault();

        this.props.router.navigate('/config/socials');

    }

    render() {
        let header = null,
            main = null,
            saveActive = _.isEqual(this.state.cleanSocial, this.state.social) ? false : true,
            saveAction = null,
            errorBlock = null,
            constants = this.props.app.config.constants,
            buttons = SocialConfigButtons.getButtons.apply(this, ['/config/social/' + this.state.social.id]),
            activePanel = '',
            errorMsg = "We couldn't complete that update. Check the highlighted tabs for details.",
            {children, ...otherProps} = this.props,
            editorButtons = null;

        // no advanced state for LinkedIn subtypes
        if (this.state.social.psID == constants.POST_SVC_FEED) {
            buttons = buttons.slice(0, 2);
        }

        if (saveActive) {
            saveAction = this.updateSocial;
        }

        // set the active panel for branching in social config panels
        activePanel = this.props.router.location.pathname.match(/([a-z]+)$/);
        if (activePanel === null) {
            activePanel = 'options';
        } else {
            activePanel = activePanel[1];
        }

        if (activePanel === 'log') {
            buttons = [];
        }

        if (this.state.errors !== null) {
			errorBlock = (
                <div className="detail-status error">
                    {errorMsg}
                </div>
            );
        }

        header = (
            <SocialEditorTabs
                {...this.props}
                socialType={this.state.social.psID}
                socialLabel={this.state.social.name} />
        );

        // fill out the props object passed to children
        otherProps.social = this.state.social;
        otherProps.changeHandler = FormUtilityMixin.requestChange.bind(this);
        otherProps.activePanel = activePanel;
        otherProps.fieldMapping = "social.params";
        otherProps.errorMapping = "params";
        otherProps.deleteHandler = this.deleteSocial;

        if (!this.props.router.location.pathname.match("log")) {
            editorButtons = (
                <EditorButtons
                    saveActive={saveActive}
                    saveLabel="Save"
                    saveAction={saveAction}
                    cancelAction={this.cancelEdit}/>
            );
        }

        let reminder = null;
        if (!this.props.router.location.pathname.match("log")) {
            reminder = (
                <div className="social-settings-reminder">
                    These settings only apply to automated posts
                </div>
            );
        }

        main = (
            <div>
                {errorBlock}
                <ButtonList buttons={buttons}
					wrapperClass="editor-tabs"
					linkClass="editor-tab-item"
					activeClass="tab-active"
					errorClass="tab-error" />
                {reminder}
                <Outlet context={otherProps}/>
                {editorButtons}
            </div>
        );

        return (
            <Content header={header} main={main} modal={this.state.currentModal}/>
        );
    }

};

SocialEditor.displayName = "SocialEditor";

SocialEditor.defaultProps = {
    appName: "dlvr"
};

export default ComponentWithContext(SocialEditor);
